<div class="fullModal opened addForm" id="AddAppwanBulkModal">
    <app-loader [isLoading]="isLoading"></app-loader>
    <div [hidden]="step !== 0" class="fullRow" id="AppWanUpload">
        <div [ngClass]="{ isAt: step === 0 }" class="stepItem">
            <div class="title" style="filter: brightness(50%)">Import your Appwan As Code</div>
            <div class="subtitle">Select Your File To Upload</div>
            <div class="sized">
                <!-- Azure BULK Add -->
                <div class="subtext row">
                    Creating AppWAN using only code is easy. Just download our template below, update the code, and
                    upload your file. We’ll create the AppWAN, Endpoints, and Services and provide you with a summary
                    and list of next steps.
                </div>
                <div class="label row">Download A Template</div>
                <div (click)="download()" class="graphicButtonYML">
                    <div>Download An<br />Example File</div>
                    <div class="iconYML"></div>
                </div>

                <div class="label row">Select And Upload A File</div>
                <div (onFileDrop)="fileDrop()" [uploader]="uploader" class="uploadArea" ng2FileDrop>
                    <div [hidden]="fileIsReady" class="label">Drag and drop a YML file</div>
                    <div [hidden]="fileIsReady" class="sublabel">
                        or
                        <div (click)="showDialog()" class="linkButton" id="AppwanFileUpload">
                            Select a file from your computer
                        </div>
                        <form [formGroup]="form">
                            <input
                                #fileInput
                                (change)="onFileChange($event)"
                                id="FileSelect"
                                name="file"
                                style="display: none"
                                type="file"
                            />
                        </form>
                    </div>
                    <div [hidden]="!fileIsReady" class="label">Click create to import YML</div>
                </div>
                <div class="row buttonRow right" style="margin-top: 1.25rem">
                    <button (click)="save()" *ngIf="!processing" class="save" id="saveAppWanButton">Create</button>
                    <button *ngIf="processing" class="save confirm" disabled>
                        Saving <span class="spinner"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div [hidden]="step !== 1" class="fullRow" id="AppWanBuildingStatus">
        <div [ngClass]="{ isAt: step === 1 }" class="sized nextStep">
            <app-appwan-bulk-upload-save
                #saveAppWanAsCode
                (uploaded)="fetchSummary()"
                [appWan]="appWan"
                [businessKey]="businessKey"
                [networkId]="networkId"
            >
            </app-appwan-bulk-upload-save>
        </div>
    </div>

    <div [hidden]="step !== 2" class="fullRow" id="AppWanUploadSummary">
        <app-appwan-upload-summary
            #showSummary
            (createNew)="resetForm()"
            [appWan]="appWan"
            [cloneMessage]="cloneMessage"
            [displaySummary]="true"
        >
        </app-appwan-upload-summary>
    </div>

    <div (click)="close()" class="buttonBall close" id="CloseAppwanUploadButton">
        <div class="buttonLabel">ESC</div>
    </div>
    <app-form-support-button *ngIf="!hideHelp"></app-form-support-button>
</div>
